import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	['atlassian-web-crawler']: {
		id: 'dynamic-cards-search-page.products.custom-website',
		defaultMessage: 'Web page',
		description: 'display name for the Atlassian web crawler 3p app option in the "Build Dynamic Cards" modal that opens when the user clicks the "View current filters" button in a dynamic cards configuration panel',
	},
});
